import {
  GetPropertiesRequest,
  MonitoredPropertiesIPropertyOverview,
  PropertiesApi,
} from "@ionenergysolutions/reporting-api";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { useApi } from "./useApi";

const getCacheKey = (request: GetPropertiesRequest) => ["properties", request];

type PaginatedMonitoredPropertiesIPropertyOverview = {
  results: MonitoredPropertiesIPropertyOverview[];
  total: number;
};

export const useProperties = (
  request: GetPropertiesRequest = {},
  options?: UseQueryOptions<PaginatedMonitoredPropertiesIPropertyOverview, Error>,
) => {
  const api = useApi(PropertiesApi);
  const query = useQuery<PaginatedMonitoredPropertiesIPropertyOverview, Error>(
    getCacheKey(request),
    async () => {
      try {
        const response = await api.getPropertiesRaw(request);
        const total = parseInt(response.raw.headers.get("x-total-count") || "", 10) || 0;
        const results = await response.value();
        return { total, results };
      } catch (e: unknown) {
        const response = e as Response;
        const json = await response.json();
        const message = json.message || response.statusText;
        throw new Error(message);
      }
    },
    options,
  );
  return query;
};
